export const mutateStateFile = (
    files: File[],
    file: File,
    value: { [key: string]: any }
) =>
    files.map((prevFile) =>
        prevFile.name === file.name ? Object.assign(prevFile, value) : prevFile
    );
